<template>
  <div class="toast-container">
    <TransitionGroup name="toast">
      <div
        v-for="item in toastState.list"
        :key="item.id"
        class="toast-item"
        :class="'toast-' + item.type"
      >
        <span class="toast-icon">{{ icons[item.type] }}</span>
        <span class="toast-text">{{ item.message }}</span>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { toastState } from '../utils/notify'

export default {
  name: 'ToastNotify',
  data() {
    return {
      toastState,
      icons: {
        success: '✓',
        error: '✕',
        info: 'ℹ'
      }
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  left: 50%;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: max-content;
  max-width: calc(100vw - 32px);
  transform: translateX(-50%);
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 240px;
  max-width: 420px;
  padding: 12px 18px;
  font-size: 14px;
  color: #f1f5f9;
  background: rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  backdrop-filter: blur(16px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  pointer-events: auto;
}

.toast-success {
  border-color: rgba(52, 211, 153, 0.4);
  box-shadow: 0 12px 32px rgba(16, 185, 129, 0.15);
}

.toast-error {
  border-color: rgba(248, 113, 113, 0.4);
  box-shadow: 0 12px 32px rgba(239, 68, 68, 0.15);
}

.toast-info {
  border-color: rgba(56, 189, 248, 0.4);
  box-shadow: 0 12px 32px rgba(14, 165, 233, 0.15);
}

.toast-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
}

.toast-success .toast-icon {
  color: #6ee7b7;
  background: rgba(16, 185, 129, 0.2);
}

.toast-error .toast-icon {
  color: #fca5a5;
  background: rgba(239, 68, 68, 0.2);
}

.toast-info .toast-icon {
  color: #7dd3fc;
  background: rgba(14, 165, 233, 0.2);
}

.toast-text {
  line-height: 1.5;
  word-break: break-word;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
